import useConsorcioStore from "../storeModules/useConsorcioStore";
import { CategoriasEnum } from "../utils/constants";

const getCategoryName = () => {
  const { categoriaId } = useConsorcioStore.getState();

  const categoryName = CategoriasEnum[categoriaId]
    ? CategoriasEnum[categoriaId].title.toLowerCase()
    : null;

  if (!categoryName) return null;

  return categoryName;
};

export default getCategoryName;
